module.exports = __webpack_public_path__ + "img/Eclipse.e6e25d9d.jpg";